module.exports = __webpack_public_path__ + "static/media/barCode.c8b1c4a9.jpg";